import styled, { createGlobalStyle } from 'styled-components';
import colors from '@service-victoria/component-library/utils/colors';
import { Wrapper } from '@service-victoria/component-library/components/Input/styled';

export const DatePickerOverrides = createGlobalStyle`
    :root {
        --duet-font: 'VIC';
        --duet-font-bold: 'VIC';
        --duet-color-surface: white;
        --duet-color-text: ${colors.blueGrey};
        --duet-z-index: 3;
        --duet-radius: 2px;
        --duet-color-overlay: rgba(0, 0, 0, 0.58);
        --duet-color-text-active: white;
        --duet-color-primary: ${colors.orange};
        --duet-color-border: ${colors.blueGrey};
    }

    .duet-date__mobile-heading {
        font-weight: 600;
    }

    .duet-date__input:focus {
        box-shadow: none;
    }

    .duet-date__dialog {
        --duet-color-primary: ${colors.blueGrey};
    }

    .duet-date__input {
        padding: 12px 60px 12px 14px;
    }
`;

export const FieldWrapper = styled(Wrapper)`
  align-items: stretch;
`;

/**
 * What is this for you say?
 *
 * The requirement is to have the existing date component with the react-mask for when the user manually enters their details
 * But we also need to have the duet date picker underneath.
 *
 * To accomplish this, we overlay an old date picker and make sure it's spaced exactly in the right way that it overlays
 */
export const InputWrapper = styled.div`
  position: relative;

  > input {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 34px);
    z-index: 1;
    margin: 0;

    &:focus {
      background: white;
    }
  }
`;
